module.exports = __webpack_public_path__ + "img/ing.7a0a1ad.png";